import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import ThreeHomeScene from "../Home/ThreeHomeScene";
import Toolstack from "./Toolstack";
import FraLibStack from "./FraLibStack";
import { useLanguage } from "../../context/LanguageContext";

function About() {
  const { t } = useLanguage();
  const a = t.about;

  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              {a.profileTitle} <strong className="purple">{a.profileHighlight}</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "50px", paddingBottom: "50px", textAlign: "center" }}
            className="about-img"
          >
            <ThreeHomeScene />
          </Col>
        </Row>

        <h1 className="project-heading">
          <strong className="purple">{a.techTitle1Highlight}</strong>
          {a.techTitle1Suffix}
        </h1>
        <Techstack />

        <h1 className="project-heading">
          {a.techTitle2Prefix}
          <strong className="purple">{a.techTitle2H1}</strong>
          {a.techTitle2Sep}
          <strong className="purple">{a.techTitle2H2}</strong>
          {a.techTitle2Suffix}
        </h1>
        <FraLibStack />

        <h1 className="project-heading">
          <strong className="purple">{a.techTitle3Highlight}</strong>
          {a.techTitle3Suffix}
        </h1>
        <Toolstack />

        <Github />
      </Container>
    </Container>
  );
}

export default About;
